import ReactDom from "react-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App'


ReactDom.render(
    
    <App />, 
    document.getElementById('root')

)